import React from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage, injectIntl} from "react-intl";

import {switchToWizardItem} from "../qkbPages/materialsWizard/useChangeWizardStepRoute";
import {getShowPrice} from "../../misc/priceFunctions";
import FeatureName from "../visComponents/featureName";

const ShoppingCartItemsListWizardCustomItem = (props) => {

  const {isMobile, wizardList, listItem, quoteIndex, showUnlockCalculations, showCartItems, fabricatorData} = props;

  const {wizardSelectedValue, wizardAllObject, stepIndex} = listItem;
  const {wizardGroup, selectedFeature} = wizardSelectedValue;

  if (showUnlockCalculations && !showCartItems.includes(quoteIndex + wizardGroup.id)) {
    return false
  }

  const handleEditClick = () => {
    const {wizardItemId} = wizardAllObject;
    const wizardItem = wizardList.find(wizItem => wizItem.id === wizardItemId) || wizardList[0];
    switchToWizardItem(wizardItem, +stepIndex, quoteIndex, wizardGroup.id);
  };

  return (
    <div className="scart-block">
      <h3 className="scart-block__title">{wizardGroup.title || wizardGroup.groupName}</h3>
      <button className="scart-block__add-more" onClick={handleEditClick}>
        <FormattedMessage id="shoppingCart.featureInCartEditLink"/>
      </button>
      <ul className={"scart-block__list" + (getShowPrice(fabricatorData) && !isMobile ? " scart-block__list--with-price" : "")}>
        <li className={"scart-block__product"}>
          <div className={"scart-block__list-item scart-block__list-item--custom"}>
            {/*<div className="scart-block__list-item-text">*/}
            <div>
              <h4 className="scart-block__list-item-text-title">
                {selectedFeature ? <FeatureName feature={selectedFeature}/> : wizardGroup.productCartTitle || wizardGroup.title || wizardGroup.groupName}
              </h4>
              {wizardGroup.productCartDescription ? (
                <p className="scart-block__list-item-text-description"
                   dangerouslySetInnerHTML={{__html: wizardGroup.productCartDescription}}/>
              ) : null}
            </div>
            {/*{isMobile ? (*/}
            {/*  <div className="scart-block__list-item-buttons">*/}
            {/*    <button className="ui-smallbutton ui-smallbutton--edit" onClick={handleEditClick}/>*/}
            {/*  </div>*/}
            {/*) : (*/}
            {/*  <Fragment>*/}
            {/*    <div className="scart-block__list-item-buttons scart-block__list-item-buttons--desktop">*/}
            {/*      <span className="link link--blue" onClick={handleEditClick}>*/}
            {/*        <FormattedMessage id="shoppingCart.featureInCartEditLink"/>*/}
            {/*      </span>*/}
            {/*    </div>*/}
            {/*    <div className="shoppingcart-block__list-item-total"/>*/}
            {/*  </Fragment>*/}
            {/*)}*/}
          </div>
        </li>
      </ul>
    </div>
  )
}

ShoppingCartItemsListWizardCustomItem.propTypes = {
  listItem: PropTypes.object.isRequired,
  quoteIndex: PropTypes.number.isRequired,
}

const mapStateToProps = (store) => {
  const {allWizardsValues, wizardList} = store.wizardState;
  const {isMobile} = store.serverState;
  const {showUnlockCalculations, showCartItems} = store.unlockCalculationsState;
  return {
    isMobile,
    fabricatorData: store.fabricatorState,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    wizardList,
    allWizardsValues,
    showUnlockCalculations,
    showCartItems,
  };
};

export default injectIntl(
  connect(mapStateToProps)(ShoppingCartItemsListWizardCustomItem)
)
